(function () {
  const ROOT_SEL = "[data-tiered-discount-bar]";
  const MODAL_SEL = "[data-tiered-discount-modal]";
  const OPEN_SEL = "[data-tiered-discount-open]";
  const CLOSE_SEL = "[data-tiered-discount-close]";
  const OPEN_CLASS = "is-open";

  function getModalFromTrigger(trigger) {
    const root = trigger && trigger.closest(ROOT_SEL);
    return root ? root.querySelector(MODAL_SEL) : null;
  }

  function moveModalToBody(modal) {
    if (!modal || modal.parentElement === document.body) return;

    const placeholder = document.createComment("tiered-discount-modal");
    modal.__tdbPlaceholder = placeholder;
    modal.parentNode.insertBefore(placeholder, modal);
    document.body.appendChild(modal);
  }

  function restoreModalPosition(modal) {
    const placeholder = modal && modal.__tdbPlaceholder;
    if (!modal || !placeholder || !placeholder.parentNode) return;

    placeholder.parentNode.insertBefore(modal, placeholder);
    placeholder.remove();
    modal.__tdbPlaceholder = null;
  }

  function openModal(modal) {
    if (!modal) return;

    moveModalToBody(modal);
    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add(OPEN_CLASS);
      const closeButton = modal.querySelector(CLOSE_SEL);
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove(OPEN_CLASS);
    window.setTimeout(() => {
      if (!modal.classList.contains(OPEN_CLASS)) {
        modal.hidden = true;
        restoreModalPosition(modal);
      }
    }, 180);
  }

  document.addEventListener("click", (event) => {
    const openButton = event.target.closest(OPEN_SEL);
    if (openButton) {
      openModal(getModalFromTrigger(openButton));
      return;
    }

    const closeButton = event.target.closest(CLOSE_SEL);
    if (closeButton) {
      closeModal(closeButton.closest(MODAL_SEL));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    document.querySelectorAll(`${MODAL_SEL}.${OPEN_CLASS}`).forEach((modal) => {
      closeModal(modal);
    });
  });
})();
